module.exports = __webpack_public_path__ + "static/img/840_phase_function_Paper_Points.5ed8d68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/840_phase_function_Paper_Points.png
// module id = bIyC
// module chunks = 0